import { z } from 'zod';
import { ComponentProps } from 'react';
import { mapPropertyStatusToBadgeWithStatus } from './mapPropertyStatusToBadge';
import { createImageUrl } from './createImageUrl';
import { propertyTileComponentSchema } from '../hooks/uiComponentsSchemas';
import { PropertyTileV2 } from '../../../../../../app-kit/components/PropertyTile/PropertyTileV2';

export function mapUIMessagePropertyTileToPropertyTileProps({
  address,
  attributes,
  imageUrl,
  propertyStatus,
}: z.infer<typeof propertyTileComponentSchema>): ComponentProps<typeof PropertyTileV2> {
  return {
    image: imageUrl ? createImageUrl(address, imageUrl) : null,
    badge: propertyStatus
      ? mapPropertyStatusToBadgeWithStatus(propertyStatus)
      : {
          text: 'Off market',
          variant: 'neutral',
        },
    subtitle: address,
    features: attributes.map((attribute) => ({
      iconName:
        attribute.attributeType === 'bedrooms'
          ? 'BedLg'
          : attribute.attributeType === 'bathrooms'
            ? 'BathLg'
            : 'CarportLg',
      title: attribute.attributeType,
      valueWithUnit: attribute.value,
    })),
  } satisfies ComponentProps<typeof PropertyTileV2>;
}
